import { use } from 'react'
import { QueryRefsContext } from '@/components/root/query-refs-context'
import { useReadQuery } from '@/lib/hooks/graphql-hooks'

export const useAuthenticatedIdUser = () => {
  const { userCompaniesQueryRef } = use(QueryRefsContext)
  const { data } = useReadQuery(userCompaniesQueryRef)

  return data?.user?.id
}
